import { MenuItem } from './MenuItem';

export class PopupMenu {
    constructor(domNode, controllerObj) {
        let elementChildren,
            msgPrefix = 'PopupMenu constructor argument domNode ';

        // Check whether domNode is a DOM element
        if (!domNode instanceof Element) {
            throw new TypeError(msgPrefix + 'is not a DOM Element.');
        }
        // Check whether domNode has child elements
        if (domNode.childElementCount === 0) {
            throw new Error(msgPrefix + 'has no element children.');
        }
        // Check whether domNode descendant elements have A elements
        let childElement = domNode.firstElementChild;
        while (childElement) {
            let menuitem = childElement.firstElementChild;
            if (menuitem && menuitem === 'A') {
                throw new Error(msgPrefix + 'has descendant elements that are not A elements.');
            }
            childElement = childElement.nextElementSibling;
        }

        this.isMenubar = false;

        this.domNode = domNode;
        this.controller = controllerObj;

        this.menuitems = []; // See PopupMenu init method
        this.firstChars = []; // See PopupMenu init method

        this.firstItem = null; // See PopupMenu init method
        this.lastItem = null; // See PopupMenu init method

        this.hasFocus = false; // See MenuItem handleFocus, handleBlur
        this.hasHover = false; // See PopupMenu handleMouseover, handleMouseout
    }

    init() {
        let childElement, menuElement, menuItem, textContent, numItems, label;

        // Configure the domNode itself

        this.domNode.parentNode.addEventListener('mouseover', this.handleMouseover.bind(this));
        this.domNode.parentNode.addEventListener('mouseout', (event) => {
            this.handleMouseout(event);
        });

        // Traverse the element children of domNode: configure each with
        // menuitem role behavior and store reference in menuitems array.
        childElement = this.domNode.querySelectorAll('.header-nav-sub-menu__item');

        [].forEach.call(childElement, (element) => {
            menuElement = element.firstElementChild;

            if (menuElement && menuElement.tagName === 'A') {
                menuItem = new MenuItem(menuElement, this);
                menuItem.init();
                this.menuitems.push(menuItem);
                textContent = menuElement.textContent.trim();
                this.firstChars.push(textContent.substring(0, 1).toLowerCase());
            }
        });

        // Use populated menuitems array to initialize firstItem and lastItem.
        numItems = this.menuitems.length;
        if (numItems > 0) {
            this.firstItem = this.menuitems[0];
            this.lastItem = this.menuitems[numItems - 1];
        }
    }

    handleMouseover() {
        this.hasHover = true;
    }

    handleMouseout(event) {
        let currentTarget = event.currentTarget;

        if (!currentTarget.contains(event.relatedTarget)) {
            this.hasHover = false;
            this.close(false);
        }
    }

    setFocusToController(command, flag) {
        if (typeof command !== 'string') {
            command = '';
        }

        function setFocusToMenubarItem(controller, close) {
            while (controller) {
                if (controller.isMenubarItem) {
                    controller.domNode.focus();
                    return controller;
                } else {
                    if (close) {
                        controller.menu.close(true);
                    }
                    controller.hasFocus = false;
                }
                controller = controller.menu.controller;
            }
            return false;
        }

        if (command === '') {
            if (this.controller && this.controller.domNode) {
                this.controller.domNode.focus();
            }
            return;
        }

        if (!this.controller.isMenubarItem) {
            this.controller.domNode.focus();
            this.close();

            if (command === 'next') {
                let menubarItem = setFocusToMenubarItem(this.controller, false);
                if (menubarItem) {
                    menubarItem.menu.setFocusToNextItem(menubarItem, flag);
                }
            }
        } else {
            if (command === 'previous') {
                this.controller.menu.setFocusToPreviousItem(this.controller, flag);
            } else if (command === 'next') {
                this.controller.menu.setFocusToNextItem(this.controller, flag);
            }
        }
    }

    setFocusToFirstItem() {
        this.firstItem.domNode.focus();
    }

    setFocusToLastItem() {
        this.lastItem.domNode.focus();
    }

    setFocusToPreviousItem(currentItem) {
        let index;

        if (currentItem === this.firstItem) {
            this.lastItem.domNode.focus();
        } else {
            index = this.menuitems.indexOf(currentItem);
            this.menuitems[index - 1].domNode.focus();
        }
    }

    setFocusToNextItem(currentItem) {
        let index;

        if (currentItem === this.lastItem) {
            this.firstItem.domNode.focus();
        } else {
            index = this.menuitems.indexOf(currentItem);
            this.menuitems[index + 1].domNode.focus();
        }
    }

    setFocusByFirstCharacter(currentItem, char) {
        let start,
            index,
            lowerCasedChar = char.toLowerCase();

        // Get start index for search based on position of currentItem
        start = this.menuitems.indexOf(currentItem) + 1;
        if (start === this.menuitems.length) {
            start = 0;
        }

        // Check remaining slots in the menu
        index = this.getIndexFirstChars(start, lowerCasedChar);

        // If not found in remaining slots, check from beginning
        if (index === -1) {
            index = this.getIndexFirstChars(0, lowerCasedChar);
        }

        // If match was found...
        if (index > -1) {
            this.menuitems[index].domNode.focus();
        }
    }

    getIndexFirstChars(startIndex, char) {
        for (let i = startIndex; i < this.firstChars.length; i++) {
            if (char === this.firstChars[i]) {
                return i;
            }
        }
        return -1;
    }

    open() {
        this.domNode.parentNode.classList.add('header-menu__item--opened');
        this.controller.setExpanded(true);
    }

    close(force) {
        let controllerHasHover = this.controller.hasHover;

        let hasFocus = this.hasFocus;

        for (let i = 0; i < this.menuitems.length; i++) {
            let mi = this.menuitems[i];
            if (mi.popupMenu) {
                hasFocus = hasFocus | mi.popupMenu.hasFocus;
            }
        }

        if (!this.controller.isMenubarItem) {
            controllerHasHover = false;
        }

        if (force || (!hasFocus && !this.hasHover && !controllerHasHover)) {
            this.domNode.parentNode.classList.remove('header-menu__item--opened');
            this.controller.setExpanded(false);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/header/scripts/a11y-navigation/PopupMenu.js